module.exports = {
    "Leave the Chat": "Leave the Chat",
    "This will disconnect all participants and end the chat. This cannot be undone - are you sure?": "/!\\ WARNING! /!\\ \n----------------\nThis will disconnect all participants and end the chat. \nThis cannot be undone - are you sure?",
    "Are you sure you want to leave the chat?": "Are you sure you want to leave the chat?",
    "The chat has been closed": "The chat has been closed",
    "Terminate the chat": "Terminate the chat",
    "Post a message to everyone": "Post a message to everyone",
    "Sorry, an error occurred.": "Sorry, an error occurred.",
    "Sorry, you must be logged in to access this Live Chat.%{login_message}": "Sorry, you must be logged in to access this Live Chat.%{login_message}",
    "Chat initialization failed. Service unavailable.": "Chat initialisation failed. Service unavailable.",
    "Click <a href=\"%{login_url}\">here</a> to log in.": "Click <a href=\"%{login_url}\">here</a> to log in.",
    "NOTIFICATION": "NOTIFICATION",
    "Close notification": "Close notification",
    "Click to reload Live Chat": "Click to reload Live Chat",
    "All Discussions": "All Discussions",
    "Filter by Topic": "Filter by Topic",
    "Followed": "Followed",
    "Followed_plural": "Followed",
    "Search…": "Search…",
    "Unanswered": "Unanswered",
    "Unread": "Unread",
    "Unread_plural": "Unread",
    "Your questions": "Your questions",
    "Live Chat": "Live Chat",
    "Off": "Off",
    "On": "On",
    "Settings": "Settings",
    "Press \"Enter\" to send": "Press \"Enter\" to send",
    "Sound notifications": "Sound notifications",
    "Order by activity": "Order by activity",
    "Cancel": "Cancel",
    "Send my alert": "Send my alert",
    "This will be shown to all people online": "This will be shown to all people online",
    "Type your full message here...": "Type your full message here...",
    "hr": "hr",
    "just now": "just now",
    "min": "min",
    "Delete": "Delete",
    "Add your message here…": "Add your message here…",
    "Post": "Post",
    "in topic %{topic}": "in topic %{topic}",
    "Optional: additional details can be added below": "Optional: additional details can be added below",
    "Ask a new question": "Ask a new question",
    "Ensure that your question has not already been asked by someone else.": "Ensure that your question has not already been asked by someone else.",
    "Ask your question here": "Ask your question here",
    "%{max_chars} characters max. (%{num_chars} left)": "%{max_chars} characters max. (%{num_chars} left)",
    "Add additional information to your question here…": "Add additional information to your question here…",
    "Post my question": "Post my question",
    "Write your question here…": "Write your question here…",
    "You need to provide a question title between 20 and 120 characters.": "You need to provide a question title between 20 and 120 characters.",
    "Select…": "Select…",
    "Please choose a category for your question": "Please choose a category for your question",
    "created at": "created at",
    "updated at": "updated at",
    "Follow": "Follow",
    "Unfollow": "Unfollow",
    "%{num_people} people on the chat": "%{num_people} people on the chat",
    "%{num_people} people on the chat_plural": "%{num_people} people on the chat",
    "%{num_insiders} Insiders Online": "%{num_insiders} Insider Online",
    "%{num_insiders} Insiders Online_plural": "%{num_insiders} Insiders Online",
    "from %{start_time} to %{end_time}": "from %{start_time} to %{end_time}",
    "Welcome %{user_firstname}": "Welcome %{user_firstname}",
    "OR": "OR",
    "Say hello, introduce yourself as an Insider": "Say hello, introduce yourself as an Insider",
    "Access current discussions": "Access current discussions",
    "Sufficient information about the role and working there": "Sufficient information about the role and working there",
    "A clear recruitment process": "A clear recruitment process",
    "Quality interviews/assessments": "Quality interviews/assessments",
    "Being able to engage with employees": "Being able to engage with employees",
    "Keeping me updated on my application status": "Keeping me updated on my application status",
    "An efficient application system": "An efficient application system",
    "Giving me feedback on my application": "Giving me feedback on my application",
    "Other": "Other",
    "Close": "Close",
    "Please specify…": "Please specify…",
    "Which 3 factors are most important to ensure a good experience when you apply to a company?": "Which 3 factors are most important to ensure a good experience when you apply to a company?",
    "Send and enter chat": "Send and enter chat",
    "Next": "Next",
    "Welcome to the Live Chat": "Welcome to the Live Chat",
    "Please answer our quick survey before joining the chat.": "Please answer our quick survey before joining the chat.",
    "Your response will not be shared in the chat or with the host.": "Your response will not be shared in the chat or with the host.",
    "The Live Chat has ended. You can still ask our Insiders questions on the PathMotion platform.": "The Live Chat has ended. You can still ask our Insiders questions on the PathMotion platform.",
    "Sorry, your message is too long.": "Sorry, your message is too long.",
    "Your computer seems to experience connectivity issues. Reconnecting%{connection_attempt}…": "Your computer seems to experience connectivity issues. Reconnecting%{connection_attempt}…",
    "Are you sure you want to delete this discussion?": "Are you sure you want to delete this discussion?",
    "Are you sure you want to delete this message?": "Are you sure you want to delete this message?",
    "More Unreads": "More Unreads",
    "Where do you search for information about a company’s diversity and inclusion policies and initiatives? (Choose top three)": "Where do you search for information about a company’s diversity and inclusion policies and initiatives? (Choose top three)",
    "Which of these things would best help indicate that a company genuinely cares about diversity and inclusion? (choose three)": "Which of these things would best help indicate that a company genuinely cares about diversity and inclusion? (choose three)",
    "Statistics about representation (e.g. demographic breakdown)": "Statistics about representation (e.g. demographic breakdown)",
    "Real life stories from employees and their experiences": "Real life stories from employees and their experiences",
    "Company information (policies, values, etc.)": "Company information (policies, values, etc.)",
    "Awards won for Diversity & Inclusion": "Awards won for Diversity & Inclusion",
    "The types of qualifications being sought during recruitment (e.g. university degrees)": "The types of qualifications being sought during recruitment (e.g. university degrees)",
    "Perceived fairness of recruitment process (e.g. blind applications)": "Perceived fairness of recruitment process (e.g. blind applications)",
    "Specific company initiatives or events (e.g. creation of dedicated D&I work groups)": "Specific company initiatives or events (e.g. creation of dedicated D&I work groups)",
    "Emphasis on diversity and inclusion in the office space (e.g. physical accessibility measures)": "Emphasis on diversity and inclusion in the office space (e.g. physical accessibility measures)",
    "Reviews on websites like Glassdoor, FairyGodBoss, etc.": "Reviews on websites like Glassdoor, FairyGodBoss, etc.",
    "Details here...": "Details here...",
    "Awards and rankings sites": "Awards and rankings sites",
    "The company\\'s website": "The company\\'s website",
    "The news or current events reporting": "The news or current events reporting",
    "Campus fairs and events": "Campus fairs and events",
    "During interviews": "During interviews",
    "Social media posts, groups, networks (e.g. Linkedin, Facebook)": "Social media posts, groups, networks (e.g. Linkedin, Facebook)",
    "Review websites (e.g. Glassdoor)": "Review websites (e.g. Glassdoor)",
    "Specialist recruitment organisations (e.g. Rare recruitment)": "Specialist recruitment organisations (e.g. Rare recruitment)",
    "This isn’t relevant to me": "This isn’t relevant to me",
    "Ignore": "Ignore",
    "Previous": "Previous"
};


//////////////////
// WEBPACK FOOTER
// ./src/locales/en-GB.po
// module id = 300
// module chunks = 0